import { render, staticRenderFns } from "./ModalAnswersDeleted.vue?vue&type=template&id=739a352e"
import script from "./ModalAnswersDeleted.vue?vue&type=script&lang=js"
export * from "./ModalAnswersDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports